import { Translation } from '@jsverse/transloco';

const fr: Translation = {
  citizen: {
    loginToContinue: 'Connectez-vous pour continuer',
  },
  location: {
    province: 'Province',
    district: 'District',
    sector: 'Secteur',
    cell: 'Cellule',
    village: 'Village',
  },
  form: {
    title: {
      addCategory: 'Ajouter une Catégorie',
      editCategory: 'Modifier la Catégorie',
      addAccount: 'Nouveau Personnel',
      editAccount: 'Modifier le Personnel',
      addInstitution: 'Nouvelle Institution',
      editInstitution: "Modifier l'Institution",
      editRole: 'Modifier le Rôle',
      newCase: 'Nouveau Cas',
      editCase: 'Modifier le Cas',
      newAnnouncement: 'Nouvelle Annonce',
      editAnnouncement: "Modifier l'Annonce",
      newCitizen: 'Nouveau Citoyen',
      editCitizen: 'Modifier le Citoyen',
      anonymousComplaint: 'Plainte Anonyme',
      orientationLevel: "Niveau d'Orientation",
      location: 'Lieu de travail (Optionnel)',
      locationDescription:
        "Si aucun lieu n'est défini, l'employé suivra les cas dans toutes les zones",
      amountDescription: 'plus sélectionnés',
      escalateCase: 'Escalader le Cas',
    },
    label: {
      kinyarwanda: 'Kinyarwanda',
      english: 'Anglais',
      french: 'Français',
      firstName: 'Prénom',
      middleName: 'Deuxième Prénom',
      lastName: 'Nom',
      documentType: 'Document',
      documentNumber: 'Numéro de document',
      name: 'Nom',
      phoneNumber: 'Numéro de téléphone',
      gender: 'Gender',
      email: 'Email',
      nationalId: "Numero d'Identité",
      province: 'Province',
      district: 'District',
      sector: 'Secteur',
      cell: 'Cellule',
      village: 'Village',
      title: 'Titre',
      password: 'Mot de passe',
      description: 'Description',
      caseType: 'Type de cas',
      severity: 'Gravité',
      victimsNumber: 'Nombre de victimes',
      trackingLevel: 'Niveau',
      estimateDays: 'Jours estimés',
      primaryOrganization: 'Organisation principale',
      informedOrganization: 'Organisations informées',
      issueLocation: "Détails de l'emplacement",
      issueDetails: 'Détails',
      orientationLevel: 'Niveau de suivi du cas',
      recordingLevel: 'Niveau',
      complaint: 'Plainte',
      search: 'Rechercher',
      goodGovernanceSection: 'Section de la Bonne Gouvernance',
      role: 'Rôle',
      occupation: 'Occupation',
      institution: 'Institution',
      from: 'Du',
      to: 'à',
      roleValidity: 'Validité du rôle',
      roleValidityDescription:
        "C'est la période où le rôle sera actif, s'il n'est pas défini, il est défini indéfiniment",
      assignPermission: 'Attribuer des permissions',
      locationSearch: 'Sélectionner',
      organization: 'Organization',
      reason: 'Motif de rejet de la plainte',
      reasonForEscalation: 'Raison pour escalader le cas',
      reasonMustBeAtLeast50Characters:
        'La raison doit être au moins de 50 caractères',
      minimumCharacters: 'minimum caractères',
      characters: 'caractères',
    },
    placeholder: {
      documentType: 'Entrer le type de document',
      documentNumber: 'Entrer le numéro de document',
      name: 'Entrer le nom',
      phoneNumber: 'Entrer le numéro de téléphone',
      gender: 'Sélectionner le genre',
      email: "Entrer l'email",
      nationalId: "Entrer le numéro d'identité",
      province: 'Sélectionner la province',
      district: 'Sélectionner le district',
      sector: 'Sélectionner le secteur',
      cell: 'Sélectionner la cellule',
      village: 'Sélectionner le village',
      password: 'Entrer le mot de passe',
      description: 'Entrer la description',
      title: 'Entrer le titre',
      complaint: 'Entrer le Plainte',
      caseType: 'Sélectionner le type de cas',
      severity: 'Sélectionner le niveau de gravité',
      victimsNumber: 'Sélectionner le nombre de victimes',
      trackingLevel: 'Sélectionner le niveau de suivi',
      estimateDays: 'Entrer les jours estimés',
      primaryOrganization: "Sélectionner l'organisation principale",
      informedOrganization: 'Sélectionner les organisations informées',
      issueLocation: "Entrer les détails de l'emplacement",
      issueDetails: 'Entrer les détails du problème',
      orientationLevel: 'Sélectionner le niveau de suivi du cas',
      recordingLevel: "Sélectionner le niveau d'enregistrement",
      searchInstitution: 'Rechercher ici',
      firstName: 'Entrer le Prénom',
      lastName: 'Entrer le Nom',
      occupation: "Entrer l'Occupation",
      institution: 'Toutes les Institutions',
      search: 'Rechercher ici',
      locationSearch: 'Sélectionner',
      organization: "Sélectionner  l'Organizaiton",
      role: 'Sélectionner  le Role',
      citizen: 'Citoyen',
      explainWhyYouAreEscalatingThisCase:
        'Expliquer pourquoi vous escaladez ce cas (minimum 50 caractères)',
    },
    button: {
      forgotPassword: 'Mot de passe oublié?',
      resetPassword: 'Réinitialiser le mot de passe',
      login: 'Connexion',
      alreadyHaveAnAccount: 'Avez-vous déjà un compte?',
      submitButton: 'Soumettre',
      signUp: "S'inscrire",
      ok: "D'accord",
      cancel: 'Annuler',
      addCategory: 'Ajouter une Catégorie',
      editCategory: 'Modifier une Catégorie',
      addAccount: 'Ajouter un Compte',
      editAccount: 'Modifier un Compte',
      addInstitution: 'Ajouter une Institution',
      editInstitution: 'Modifier une Institution',
      editRole: 'Modifier le Rôle',
      newCase: 'Nouveau Cas',
      editCase: 'Modifier Cas',
      newAnnouncement: 'Nouvelle Annonce',
      editAnnouncement: 'Modifier une Annonce',
      newCitizen: 'Nouveau Citoyen',
      editCitizen: 'Modifier le Citoyen',
      casesStatus: {
        closed: 'Fermé',
        ongoing: 'En cours',
        done: 'Résolu',
        resolved: 'Résolu',
        reopened: 'Re-ouverte',
        re_opened: 'Re-ouverte',
      },
    },
    options: {
      severity: {
        low: 'Faible',
        medium: 'Moyen',
        high: 'Élevé',
        critical: 'Critique',
      },
      trackingLevel: {
        national: 'Nation',
        province: 'Province',
        district: 'District',
        sector: 'Secteur',
        cell: 'Cellule',
        village: 'Village',
      },
      victimsNumber: {
        one: 'Un',
        multiple: 'Multiple',
      },
    },
    errors: {
      emailPhoneRequired: 'Email ou numéro de téléphone est requis',
      passwordRequired: 'Le mot de passe doit contenir au moins 8 caractères',
      codeRequired: 'Le code de vérification est requis',
    },
  },

  resetPasswordForm: {
    title: 'Réinitialisez votre mot de passe',
    description:
      'Définissez un nouveau mot de passe pour continuer et accéder à la plateforme',
    label: {
      code: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe',
    },
    placeholder: {
      code: 'Entrez le mot de passe actuel',
      enterNewPassword: 'Entrez le nouveau mot de passe',
    },
    button: 'Confirmer le nouveau mot de passe',
  },
  casesStatus: {
    closed: 'Fermé',
    ongoing: 'En cours',
    done: 'Résolu',
    reopened: 'Re-ouverte',
    pending: 'Pending',
  },

  announcementStatus: {
    published: 'Publié',
    unpublished: 'Expiré',
  },
  noCasesFound: 'Aucun cas trouvé',
  fetchingData: 'Récupération des données...',
  editPersonalInfo: 'Informations Personnelles',
  editPersonalInfoDescription:
    "Ces informations sont récupérées à partir de votre carte d'identité et ne peuvent pas être modifiées",
  changePassword: 'Changer le mot de passe',
  changePasswordDescription:
    'Entrez votre mot de passe actuel pour changer votre mot de passe',
  currentPassword: 'Mot de passe actuel',
  confirmPassword: 'Confirmer le mot de passe',
  enterConfirmPassword: 'Entrer le mot de passe de confirmation',
  enterCurrentPassword: 'Entrer le mot de passe actuel',
  // MENU
  dashboard: 'Tableau de bord',
  complaints: 'Plainte',
  announcements: 'Annonces',
  tipOffs: 'Signalement',
  notificationSettings: 'Paramètres de notification',
  notificationSettingsDescription:
    'Configurez les notifications quotidiennes de vos cas et plaintes.',
  addReportingNotification: 'Ajouter une notification de rapport',
  createNotification: 'Créer la notification',
  reportingNotificationHelperText:
    "Créez des notifications de rapport selon le niveau de suivi, les lieux assignés et l'adresse e-mail de destination.",
  notificationChannelDescription:
    'Activez ou désactivez ce canal de notification pour votre compte.',
  selectRecordingLevel: 'Sélectionnez le niveau de suivi',
  selectOrganization: "Sélectionnez l'organisation",
  assignedLocations: 'Lieux assignés',
  searchAssignedLocations: 'Rechercher des lieux assignés',
  enterNotificationEmail: "Saisissez l'e-mail de notification",
  assignedLocationRequired: 'Au moins un lieu est requis',
  manage: 'Gérer',
  citizens: 'Citoyens',
  institutions: 'Institutions',
  accounts: 'Comptes',
  security: 'Security',
  overview: 'Aperçu',
  cases: 'Cas',
  analytics: 'Analyse',
  staff: 'Staff',
  rolesAndPermissions: 'Rôles & Permissions',
  systemSettings: 'Paramètres du Système',
  auditLog: "Journal d'audit",
  tipOffCategories: 'Catégorie de Signalement ',

  tipOffCategoryPage: {
    title: 'TipOff Categories',
    description: 'Manage tip-off categories',
    action: {
      addNewCategory: 'Add Category',
    },
  },
  modal: {
    title: 'Filtre',
    byInstitution: 'Par Institution',
    clear: 'Effacer les Filtres',
    apply: 'Appliquer les Filtres',
    edit: 'Modifier ',
    view: 'Voir ',
    deactivate: 'Désactiver',
    activate: 'Activer',
    delete: 'Supprimer',
  },
  noDocumentsFound: 'Aucun document trouvé',
  home: 'Accueil',
  quickOverview: 'Aperçu rapide',
  announcement: 'Annonces',
  myDashboard: 'Mon tableau',
  welcome: 'Bienvenue',
  tipOffCategory: 'Catégorie',
  tipOffCategoryPlaceholder: 'Sélectionnez une catégorie de signalement',
  newAnonymousComplaint: 'Signaler anonymement',
  issueDescription: 'Description du Problème',
  enterIssueDescription: 'Entrer la description du problème',
  issueTitlePlaceholder: 'Entrer le titre du problème',
  reportAnonymously: 'Signaler anonymement',
  submitComplaint: 'Soumettre Plainte',
  submitComplaintButton: 'Soumettre une Plainte',
  newComplaint: 'Nouvelle Plainte',
  closed: 'Fermé',
  ongoing: 'En cours',
  nationalId: "Carte d'identité",
  name: 'Nom',
  phoneNumber: 'Numéro de téléphone',
  gender: 'Genre',
  email: 'Email',
  complaintsAndCases: 'Plaintes & Cas',
  searchHere: 'Rechercher ici',
  underReview: 'En cours de révision',
  myComplaints: 'Mes Plaintes',
  statusOngoing: 'En cours',
  statusPending: 'En Attente',
  statusReOpened: 'Re-ouverte',
  statusClosed: 'Fermé',
  statusDone: 'Résolu',
  issueLocation: 'Emplacement du Problème',
  district: 'District',
  sector: 'Sector',
  cell: 'Cell',
  village: 'Village',
  selectDistrict: 'Sélectionner District',
  selectSector: 'Sélectionner Secteur',
  selectCell: 'Sélectionner Cellule',
  selectVillage: 'Sélectionner Village',
  issueDetails: 'Détails du Problème',
  title: 'Titre',
  complaint: 'Plainte',
  complaintTitle: 'Titre de la Plainte',
  typeYourComplaint: 'Écrivez votre plainte',
  download: 'Télécharger',
  noFilesAttached: 'Aucun fichier',
  complaintDetails: 'Détails de la Plainte',
  reportedOn: 'Reporté le',
  close: 'Fermer',
  loading: 'Chargement...',
  supportingAttachments: 'Documents justificatives',
  caseDetails: 'Détails du Cas',
  reportedBy: 'Reporté par',
  informedInstitutions: 'Institutions informées',
  noOrganizationsInformed: 'Aucune institution informée',
  caseTimeline: 'Chronologie du Cas',
  trackingLevel: 'Niveau de suivi',
  createdBy: 'Créé par',
  assignedTo: 'Assigné à',
  primaryOrganization: 'Organisation principale',
  none: 'Aucun',
  myProfile: 'Mon Profil',
  profile: 'Profil',
  logout: 'Déconnexion',
  login: 'Connexion',
  register: 'Registre',
  landingPageTitle: 'Bienvenue sur Mbaza',
  trackComplaint: 'Suivre une plainte',
  tracking: 'Suivre une plainte ',
  trackingPlaceholder: 'Entrez le numéro de suivi',
  trackAnotherComplaint: 'Suivre une autre plainte',
  reportedAComplaint: 'A signalé une plainte',
  createdACase: 'A créé un cas',
  addedAComment: 'A ajouté un commentaire',
  tagged: 'A tagué',
  you: 'vous',
  trackYourComplaint: 'Suivre votre plainte',
  mostCasePerDistrict: 'La plupart des cas par district',
  mostCasePerInstitution: 'La plupart des cas par institutions',
  mostCasePerCategory: 'La plupart des cas par catégorie',
  mostCasePerChannel: 'La plupart des cas par canal',
  caseTrendThisYear: 'Tendance des cas cette année',
  casesOnTheMap: 'Cas sur la carte',
  notifications: 'Notifications',
  newCase: 'Nouveau Cas',
  createCase: 'Créer un Cas',
  nonOrientedComplaints: 'Plaintes non orientées',
  filterComplaints: 'Filtrer les plaintes',
  today: "Aujourd'hui",
  thisWeek: 'Cette Semaine',
  thisMonth: 'Ce Mois',
  thisYear: 'Cette Année',
  allTime: 'Tout le Temps',
  enterNamesKeyword: 'Entrer les noms, mots-clés, etc...',
  retry: 'Réessayer',
  urgentCases: 'Cas Urgent',
  urgent: 'Urgent',
  notUrgent: 'Pas Urgent',
  nothingToShow: 'Aucun affichage',
  thisListIsEmpty: 'Cette liste est vide',
  filter: 'Filtrer',
  allCases: 'Tous les Cas',
  selectStatus: 'Sélectionner le Statut',
  selectCategory: 'Sélectionner la Catégorie',
  selectOwnership: 'Sélectionner la Possession',
  primaryCases: 'Cas Primaire',
  secondaryCases: 'Cas Secondaire',
  status: 'Statut',
  type: 'Type',
  filterCases: 'Filtrer les Cas',
  byProvince: 'Par province',
  byLocation: 'Par Emplacement',
  byPeriod: 'Par Période',
  byStatus: 'Par Statut',
  byInstitutions: 'Par Institutions',
  bySeverityAndUrgency: 'Par Urgence',
  institution: 'Institution',
  severity: 'Gravité',
  urgency: 'Urgence',
  ownership: 'Propriété',
  allStatus: 'Tous les Statuts',
  allTypes: 'Tous les Types',
  allOwnerships: 'Tous les Propriétaires',
  allProvinces: 'Toutes les Provinces',
  allDistricts: 'Tous les Districts',
  allSectors: 'Tous les Sectors',
  allCells: 'Tous les Cellules',
  allVillages: 'Tous les Villages',
  allInstitutions: 'Tous les Institutions',
  allSeverities: 'Tous les Gravités',
  allUrgencies: 'Tous les Urgences',
  clearFilters: 'Effacer les Filtres',
  filterList: 'Filtrer la Liste',
  dateRange: 'Date Range',
  period: 'Période',
  selectHere: 'Sélectionner ici',
  mostCasesPerCategory: 'La plupart des cas par Catégorie',
  mostCasesPerInstitutions: 'La plupart des cas par Institutions',
  mostCasesPerDistrict: 'La plupart des cas par District',
  noDataAvailable: 'Aucune donnée disponible',
  totalCases: 'Tous les Cas',
  new: 'Nouveau',
  reopened: 'Re-ouverte',
  avgReactionTime: 'Temps de réaction moyen',
  reactionTimeDay: 'jour',
  reactionTimeDays: 'jours',
  reactionTimeHour: 'heure',
  reactionTimeHours: 'heures',
  reactionTimeAnd: 'et',
  avgSatisfaction: 'Satisfaction moyenne',
  done: 'Résolu',
  casesTrendPerYear: 'Tendance des cas par année',
  totalCitizens: 'Total des Citoyens',
  withOngoingCases: 'Avec des cas en cours',
  avgCasesPerUser: 'Moyenne de cas par utilisateur',
  avgCasesPerInstitution: 'Moyenne de cas par Institutions',
  female: 'Femme',
  male: 'Homme',
  foreigners: 'Étrangers',
  newCitizen: 'Nouveau Citoyen',
  createCitizen: 'Créer un Citoyen',
  saveChanges: 'Enregistrer les Changements',
  editCitizen: 'Modifier le Citoyen',
  numberOfCases: 'Nombre de cas',
  totalInstitutions: 'Total des Institutions',
  institutionsWithOngoingCases: 'Institutions avec des cas en cours',
  newInstitution: 'Nouvelle Institution',
  addInstitution: 'Ajouter une Institution',
  //TODO:update
  ongoingCases: 'Cas en cours',
  closedCases: 'Cas Ferme',
  resolvedCases: 'Cas Resolue',
  reOpenedCases: 'Cas Re-Ouvert',

  joined: 'Rejoint',
  myCases: 'Mes Cas',
  taggedCases: 'Cas Taggués',
  organizationDetails: "Détails de l'Organisation",
  performance: 'Performance',
  admin: 'Admin',
  addStaff: 'Ajouter un Staff',
  newStaff: 'Nouveau Staff',
  systemAccounts: 'Comptes Système',
  role: 'Rôle',
  lastLogin: 'Dernière Connexion',
  edit: 'Modifier',
  addAccount: 'Ajouter un Compte',
  addRole: 'Ajouter un Rôle',
  usedBy: 'Utilisé par',
  roles: 'Rôles',
  newRole: 'Nouveau Rôle',
  newAnnouncement: 'Nouvelle Annonce',
  unpublish: 'Dépublier',
  expiresAt: 'Expire le',
  announcementTitle: "Titre de l'Annonce",
  enterTitle: 'Entrer le titre',
  announcementValidity: "Validité de l'Annonce",
  expiryDate: "Date d'Expiration",
  publishAnnouncement: "Publier l'Annonce",
  yourAnnouncement: 'Votre Annonce',
  announcementValidityDescription:
    "C'est la période où l'annonce sera active, si elle n'est pas définie, elle sera définie à 5 jours à partir de la date de publication",
  published: 'Publié',
  unpublished: 'Expiré',
  reviewComplaint: 'Revoir la plainte',
  rating: 'Note',
  commentsOptional: 'Commentaires (Optionnel)',
  shareYourFeedback: 'Partagez votre feedback...',
  reporterReview: 'Revue du Reporter',
  enterNationalId: "Entrer la carte d'identité",
  continue: 'Continuer',
  haveAnAccount: 'Avez-vous un compte?',
  selectYourPhoneNumber: 'Sélectionnez votre numéro de téléphone',
  associatedPhoneNumbers:
    "Numéros de téléphone associés à votre carte d'identité",
  requestVerificationCode: 'Demander un code de vérification',
  verificationCode: 'Code de vérification',
  verificationCodeDescription:
    'Vous avez reçu un code de vérification sur votre numéro de téléphone {{ phone }}',
  verifyCode: 'Vérifier le code',
  completeYourRegistration: 'Compléter votre inscription',
  completeRegistrationDescription:
    'Complétez vos informations pour compléter votre inscription',
  firstName: 'Prénom',
  lastName: 'Nom',
  enterEmail: "Entrer l'email",
  password: 'Mot de passe',
  enterPassword: 'Entrer le mot de passe',
  signUp: "S'inscrire",
  emailOrPhone: 'Email / Téléphone',
  enterEmailOrPhoneNumber: 'Entrer un email ou un numéro de téléphone',
  forgotPassword: 'Mot de passe oublié?',
  resetPassword: 'Réinitialiser le mot de passe',
  createDefaultPassword: 'Créer un mot de passe temporaire',
  defaultPassword: 'Mot de passe temporaire',
  enterDefaultPassword: 'Saisir le mot de passe temporaire',
  defaultPasswordFor: 'Définir un mot de passe temporaire pour',
  goToLogin: 'Aller à la connexion',
  code: 'Code',
  enterCode: 'Entrer le code',
  newPassword: 'Nouveau mot de passe',
  enterNewPassword: 'Entrer le nouveau mot de passe',
  confirmPasswordReset: 'Confirmer la réinitialisation du mot de passe',
  noNotificationsFound: 'Aucune notification trouvée',
  mentionedYouInACommentOnCase:
    'vous a mentionné dans un commentaire sur le cas',
  invitedYouToACase: 'vous a invité à un cas',
  markAllAsRead: 'Tout marquer comme lu',
  caseNotAccessible: "Vous n'avez pas accès à ce cas",
  caseNotAccessibleHint:
    "Vous avez été notifié au sujet de ce cas, mais il est en dehors de votre périmètre d'accès. Demandez à la personne qui vous a mentionné d'inviter votre institution.",
  caseNotFound: 'Cas introuvable',
  caseLoadFailed: "Le cas n'a pas pu être chargé",
  backToCases: 'Retour aux cas',
  selectInstitution: 'Sélectionner une Institution',
  manageCaseCategoriesDescription:
    'Gérer les catégories de cas disponibles et leurs descriptions.',
  caseCategories: 'Catégories de cas',
  addCaseCategory: 'Ajouter une catégorie de cas',
  updateCaseCategory: 'Modifier une catégorie de cas',
  deleteCaseCategory: 'Supprimer une catégorie de cas',
  caseCategoryName: 'Nom de la catégorie de cas',
  caseCategoryDescription: 'Description de la catégorie de cas',
  enterCaseCategoryName: 'Entrer le nom de la catégorie de cas',
  enterCaseCategoryDescription: 'Entrer la description de la catégorie de cas',
  editAnnouncement: "Modifier l'Annonce",
  tipoffs: 'Signalements',
  institutionCases: 'Cas par Institution',
  permissions: 'Permissions',
  caseCategoriesSettings: 'Paramètres des Catégories de Cas',
  createdAt: 'Créé le',
  description: 'Description',
  refreshAnalytics: 'Actualiser les Analyse',
  analyticsRefreshed: 'Analyse actualisée avec succès',
  errorRefreshingAnalytics: "Erreur lors de l'actualisation de l'analyse",
  organization: 'Organisation',
  occupation: 'Occupation',
  private: 'Privé',
  noTimestamp: 'Aucune marque de temps',
  theCaseWasMarkedAs: 'Le cas a été marqué comme',
  theCaseWasEscalatedTo: 'Le cas a été escaladé vers',
  escalatedTheCaseTo: 'escaladé le cas vers',
  rejectComplaint: 'Rejeter la plainte',
  closeComplaint: 'Fermer la plainte',
  confirmClose: 'Confirmer',
  addAComment: 'Ajouter un commentaire',
  commentIsRequired: 'Le commentaire est requis',
  thisCommentWillBeRecordedWithTheComplaintClosure:
    'Ce commentaire sera enregistré avec la fermeture de la plainte',
  explainWhyThisComplaintIsBeingClosed:
    'Expliquer pourquoi cette plainte est fermée',
  minimum: 'Minimum',
  characters: 'caractères',
  comment: 'Commentaire',
  createACase: 'a créé un cas.',
  markedAs: 'Le cas a été marqué comme',
  escalated: 'a escaladé le cas vers',
  charactersCount: 'Nombre de caractères',
  systemConfiguration: {
    title: 'Comment souhaitez-vous recevoir les notifications',
    description: 'Modifier les préférences de notification',
    label: 'Configuration du système',
  },
  markAs: 'MARQUER COMME',
  success: 'Succès',
  all: 'Tout',
  totalSubmittedComplaints: 'Total des Plaintes Soumises',
  rejectedComplaints: 'Plaintes Rejetées',
  isAcknowledged: 'Accusé de Réception',
  loadMore: 'Voir plus',
  totalRatings: 'Total des Notes',
  orientedCases: 'Cas Orientés',
  dismissedComplaints: 'Plaintes Rejetées',
  acknowledgedComplaints: 'Plaintes Accusées de Réception',
  pendingComplaints: 'Plaintes en Attente',
  avgComplaintsPerDay: 'Moyenne de plaintes par jour',
  casesActivity: 'Plaintes Orientées vs Non-Orientées vs Accusées de Réception',
  casesActivityDescription:
    'Répartition des plaintes par activité (Orienté vs Non-Orienté vs Accusé de Réception)',
  casesPerLocation: 'Cas par Emplacement',
  casesPerLocationDescription:
    'Répartition des plaintes par emplacement dans votre juridiction',
  casesPerLocationRanking: 'Classement des Cas par Emplacement',
  casesPerLocationRankingDescription:
    'Classement des emplacements par le nombre de plaintes reçues (Top 5 emplacements)',
  allLocationsOrientedComplaints:
    'Tous les emplacements ont orienté leurs plaintes',
  orientedCasesPerStatus: 'Cas Orientés par Statut',
  orientedCasesPerStatusDescription:
    'Répartition des plaintes par statut (Ouvert, Fermé, Re-ouvert, Résolu, Rejeté)',
  orientedCasesPerLocation: 'Cas Orientés par Emplacement',
  orientedCasesPerLocationDescription:
    'Répartition des plaintes par emplacement dans votre juridiction',
  orientedCasesPerLocationRanking:
    'Classement des Cas Orientés par Emplacement',
  orientedCasesPerLocationRankingDescription:
    'Classement des emplacements par le nombre de plaintes orientées (Top 5 emplacements)',
  accountsUsage: 'Utilisation des Comptes',
  accountsUsageDescription:
    'Utilisation des comptes dans votre juridiction. Les comptes actifs sont ceux qui ont connecté au moins une fois dans les 5 derniers jours.',
  activeAccountsByRole: "Comptes Actifs de l'Officier de Plaintes",
  activeAccountsByRoleDescription:
    "Classement des rôles selon le nombre de comptes actifs de l'Officier de Plaintes (excluant les comptes des autres staff)",
  noActiveAccountsByRole: 'Aucun compte actif trouvé',
  accountsPerLocation: 'Comptes par Emplacement',
  accountsPerLocationDescription:
    'Répartition des comptes par emplacement dans votre juridiction',
  complaintStatistics: 'Statistiques des Plaintes',
  active: 'Actif',
  inactive: 'Inactif',
  platformStatistics: "Statistiques d'Utilisation du Système",
  resolved: 'Résolu',
  nonOriented: 'Non-Orienté',
  oriented: 'Orienté',
  dismissed: 'Rejeté',
  province: 'Province',
  filterByLocation: 'Filtrer par Emplacement',
  escalationNote: "Note d'Escalade",
  officerComment: "Commentaire de l'Officier",
  chatAssistant: {
    title: 'Assistant Mbaza',
    subtitle: 'Posez des questions sur vos données',
    emptyGreeting:
      "Posez-moi une question sur les plaintes des citoyens, l'activité du personnel ou la performance des districts.",
    placeholder: 'Posez une question sur les plaintes, tendances...',
    send: 'Envoyer',
    error: "Désolé, je n'ai pas pu obtenir de réponse. Veuillez réessayer.",
    toastError: "Échec de l'obtention d'une réponse de l'assistant",
    openAriaLabel: "Ouvrir l'assistant de discussion",
    closeAriaLabel: "Fermer l'assistant de discussion",
    suggestions: {
      locationPerformance:
        'Comment mon emplacement se porte-t-il en matière de plaintes ?',
      staffLogins:
        "Combien d'agents se sont connectés au cours du dernier mois ?",
      unresolvedByDistrict:
        'Quel district a le plus de plaintes non résolues ?',
      avgResolutionTime: 'Quel est le temps moyen de résolution des plaintes ?',
      emergingTrends:
        'Y a-t-il des tendances émergentes de plaintes cette semaine ?',
    },
  },
};

export default fr;
